import React, {useContext, useState, Component} from 'react';
import { AuthContext } from "../../Auth.js"
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import {Inject, ScheduleComponent, Month, ViewsDirective, ViewDirective} from '@syncfusion/ej2-react-schedule';
import Styles from './UserPage.module.css'
import { createElement } from '@syncfusion/ej2-base';
import EpicMenu from '../../componentes/Menus/EpicMenu';

function Asistencias() {
    const { currentUser } = useContext(AuthContext)
    const [userName] = useState(currentUser.name)

    return (
    <div >
        <div className='header'>
            <EpicMenu />
            <div className='inline'>Asistencia</div>
        </div>
        <Calendario userName={userName}/>
    </div>
    )
}

class Calendario extends Component{
	constructor(props){
		super(props);
		this.app= firebase;
		this.database = this.app.firestore().collection('Asistencia')

		this.state = {
			asistencias: [],
            employee:this.props.userName,
            falta:'',
		}
	}
    setReference=()=>{
        let dbReference=this.database
        dbReference=this.filterByEmployee(dbReference)
        return dbReference
    }
    filterByEmployee=dbReference=>{
        if(this.state.employee==='' || this.state.employee==='all') return dbReference
        return dbReference.where('empleado', '==', this.state.employee)   
    }

	componentDidMount(){
		this.setReference().onSnapshot(querySnapshot =>{
			this.setState({asistencias:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.asistencias;
                if(doc.data().falta==='no'){
                    this.setState({
                        falta: 'Asistencia'
                    })
                }else{
                    this.setState({
                        falta: 'Falta'
                    })
                }
				previousAct.push({
					id: doc.id,
					empleado: doc.data().empleado,
                    Subject: this.state.falta,
                    Description: this.state.falta,
					fecha:doc.data().fecha.toDate(),
                    StartTime: doc.data().fecha.toDate(),
                    EndTime: doc.data().fecha.toDate(),
					horario: 'De '+doc.data().hEntrada+' a '+doc.data().hSalida,
                    status: 'Completed',
                    IsAllDay: true,
				})
				this.setState({
					asistencias: previousAct
				})
			})
        })
    }
    onRenderCell(args) {
        if (args.elementType !== 'monthCells') {
            let weekEnds = [0, 6];
            console.log(args)
            if (weekEnds.indexOf((args.date).getDay()) >= 0) {
                let ele = createElement('div', {
                    innerHTML: "<img src='https://ej2.syncfusion.com/demos/src/schedule/images/newyear.svg' />",
                    className: 'templatewrap'
                });
                (args.element).appendChild(ele);
            }
        }
    }
    render() {
        return (
        <div className='body'>
            <link href="https://cdn.syncfusion.com/ej2/material.css" rel="stylesheet" type="text/css" />
        
            <ScheduleComponent renderCell={this.onRenderCell.bind(this)} cssClass='schedule-cell-template'
            editable={false} readonly={true} height='550px' width='100%' currentView='Month' 
            eventSettings={{dataSource: this.state.asistencias,
            fields:{
                id: 'id',
                subject: { name: 'Subject' },
                descripcion: { name: 'Description'},
                isAllDay: { name: 'IsAllDay' },
                startTime: { name: 'StartTime' },
                endTime: { name: 'EndTime' }
            } 
            }}>
                <ViewsDirective>
                    <ViewDirective option='Month' />
                </ViewsDirective>
                <Inject services={[Month]} />
            </ScheduleComponent>
        </div>
        )
    }
}

export default Asistencias;